// 自動ログアウト設定
export const AUTO_LOGOUT_CONFIG = {
  // デフォルト設定：毎日深夜3時59分
  defaultHour: 3,
  defaultMinute: 59,

  // 設定可能な時間範囲
  allowedHours: Array.from({ length: 24 }, (_, i) => i), // 0-23時
  allowedMinutes: Array.from({ length: 60 }, (_, i) => i), // 0-59分

  // 事前通知設定（ログアウト何分前に通知するか）
  warningMinutes: [10, 5, 1], // 10分前、5分前、1分前に警告

  // ローカルストレージのキー
  storageKey: 'waton_auto_logout_settings',

  // デバッグモード（開発時のみ）
  debug: process.env.NODE_ENV === 'development',
};

// 自動ログアウト設定の型
export interface AutoLogoutSettings {
  enabled: boolean;
  hour: number;
  minute: number;
  lastLogout?: string; // 最後にログアウトした日時
}

// デフォルト設定
export const DEFAULT_AUTO_LOGOUT_SETTINGS: AutoLogoutSettings = {
  enabled: true,
  hour: AUTO_LOGOUT_CONFIG.defaultHour,
  minute: AUTO_LOGOUT_CONFIG.defaultMinute,
};

// 設定を読み込む
export const loadAutoLogoutSettings = (): AutoLogoutSettings => {
  try {
    const saved = localStorage.getItem(AUTO_LOGOUT_CONFIG.storageKey);
    if (saved) {
      return { ...DEFAULT_AUTO_LOGOUT_SETTINGS, ...JSON.parse(saved) };
    }
  } catch (error) {
    console.error('自動ログアウト設定の読み込みエラー:', error);
  }
  return DEFAULT_AUTO_LOGOUT_SETTINGS;
};

// 設定を保存する
export const saveAutoLogoutSettings = (settings: AutoLogoutSettings): void => {
  try {
    localStorage.setItem(AUTO_LOGOUT_CONFIG.storageKey, JSON.stringify(settings));
  } catch (error) {
    console.error('自動ログアウト設定の保存エラー:', error);
  }
};

// 次のログアウト時刻を計算
export const getNextLogoutTime = (settings: AutoLogoutSettings): Date => {
  const now = new Date();
  const logoutTime = new Date();
  logoutTime.setHours(settings.hour, settings.minute, 0, 0);

  // 今日のログアウト時刻を過ぎていたら明日に設定
  if (logoutTime <= now) {
    logoutTime.setDate(logoutTime.getDate() + 1);
  }

  return logoutTime;
};

// ログアウトまでの残り時間（分）を計算
export const getMinutesUntilLogout = (settings: AutoLogoutSettings): number => {
  const now = new Date();
  const logoutTime = getNextLogoutTime(settings);
  const diffMs = logoutTime.getTime() - now.getTime();
  return Math.floor(diffMs / (1000 * 60));
};